/* BE Gratis-Seife (Test): legt 1x Saponifico Aquaviva Gelsomino (BE3200) automatisch in den Warenkorb,
   sobald der Warenkorbwert ohne die Seife >= 59 EUR ist, und entfernt sie darunter.
   Der Preis (0,00 EUR) kommt ausschliesslich vom Shopify-Rabatt "Kaufe X, erhalte Y". Kein eigener Preis hier. */
(() => {
  const VARIANT_ID = 48228221026646; // Gelsomino 150 g, SKU BE3200
  const MIN_CENTS = 5900;            // 59,00 EUR, Warenkorbwert vor Rabatten, ohne die Seife
  const PROP = '_gratis_seife';      // versteckte Positions-Eigenschaft, markiert die Gratis-Zeile
  const K_ADDED = 'be_gift_added';   // sessionStorage: wir haben die Seife hinzugefuegt
  const K_OFF = 'be_gift_off';       // sessionStorage: nicht erneut hinzufuegen (Kunde entfernt / ausverkauft)
  const K_TOKEN = 'be_gift_token';   // sessionStorage: cart.token, zu dem die Merker gehoeren
  const store = {
    get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  const post = (url, body) => fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  });
  let busy = false;
  let timer;

  async function refresh() {
    if (document.getElementById('main-cart')) { location.reload(); return; } // Warenkorbseite
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const secs = drawer.getSectionsToRender();
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const res = await (await fetch(`${root}?sections=${secs.map((s) => s.id).join(',')}`)).json();
    secs.forEach((s) => document.querySelectorAll(s.selector).forEach((el) => {
      try { el.innerHTML = drawer.getSectionInnerHTML(res[s.id], s.selector); } catch (e) {}
    }));
    const inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
  }

  async function sync() {
    if (busy) return;
    busy = true;
    try {
      const cart = await (await fetch(`${routes.cart_url}.js`)).json();
      if (store.get(K_TOKEN) !== cart.token) { store.set(K_TOKEN, cart.token); store.set(K_ADDED, '0'); store.set(K_OFF, '0'); } // neuer Warenkorb (z. B. nach Bestellung): Zustand zuruecksetzen
      if (cart.item_count === 0) { store.set(K_ADDED, '0'); store.set(K_OFF, '0'); return; } // leerer Warenkorb: Zustand zurücksetzen
      if (cart.currency !== 'EUR') return; // 59-EUR-Schwelle nur in EUR
      const gift = cart.items.find((i) => i.variant_id === VARIANT_ID && i.properties && i.properties[PROP]);
      const value = cart.items.reduce((s, i) => (i === gift ? s : s + i.original_line_price), 0);
      let changed = false;
      if (gift && value < MIN_CENTS) {
        await post(`${routes.cart_change_url}.js`, { id: gift.key, quantity: 0 });
        store.set(K_ADDED, '0');
        changed = true;
      } else if (gift && gift.quantity > 1) {
        await post(`${routes.cart_change_url}.js`, { id: gift.key, quantity: 1 });
        changed = true;
      } else if (!gift && value >= MIN_CENTS) {
        if (store.get(K_ADDED) === '1') { store.set(K_OFF, '1'); store.set(K_ADDED, '0'); } // Kunde hat sie entfernt
        if (store.get(K_OFF) !== '1') {
          const r = await post(`${routes.cart_add_url}.js`, { items: [{ id: VARIANT_ID, quantity: 1, properties: { [PROP]: '1' } }] });
          if (r.ok) { store.set(K_ADDED, '1'); changed = true; } else { store.set(K_OFF, '1'); } // Bestand 0: still ignorieren
        }
      }
      if (changed) await refresh();
    } catch (e) { /* still */ } finally { busy = false; }
  }

  const schedule = () => { clearTimeout(timer); timer = setTimeout(sync, 400); };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  document.addEventListener('cart-drawer:open', schedule);
  if (document.getElementById('main-cart')) schedule();
})();
